// Services
import callAPI from "../callApi";
import path from "../variables";

const Routes = {
	getAll: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/planning/travelroutes${filter ? filter : ""}`,
			"",
			"getting all routes"
		),
	create: (data: any) =>
		callAPI("POST", `${path.base}/planning/travelroutes`, data, "creating new route"),

	// ─── Arrêts intermédiaires (P1) ─────────────────────────────
	stops: {
		list: (routeUuid: string) =>
			callAPI(
				"GET",
				`${path.base}/planning/travel-routes/${routeUuid}/stops`,
				"",
				"list travel route stops"
			),
		create: (routeUuid: string, data: any) =>
			callAPI(
				"POST",
				`${path.base}/planning/travel-routes/${routeUuid}/stops`,
				data,
				"create travel route stop"
			),
		update: (stopUuid: string, data: any) =>
			callAPI(
				"PUT",
				`${path.base}/planning/travel-routes/stops/${stopUuid}`,
				data,
				"update travel route stop"
			),
		remove: (stopUuid: string) =>
			callAPI(
				"DELETE",
				`${path.base}/planning/travel-routes/stops/${stopUuid}`,
				"",
				"delete travel route stop"
			),
		// Réordonne avec un tableau d'UUIDs dans l'ordre voulu.
		reorder: (routeUuid: string, stopUuids: string[]) =>
			callAPI(
				"PUT",
				`${path.base}/planning/travel-routes/${routeUuid}/stops/reorder`,
				{ stop_uuids: stopUuids },
				"reorder travel route stops"
			),
	},

	// ─── Tarifs segmentés (P1) ──────────────────────────────────
	rateSegments: {
		list: (routeUuid: string) =>
			callAPI(
				"GET",
				`${path.base}/planning/travel-routes/${routeUuid}/rate-segments`,
				"",
				"list rate segments"
			),
		create: (routeUuid: string, data: any) =>
			callAPI(
				"POST",
				`${path.base}/planning/travel-routes/${routeUuid}/rate-segments`,
				data,
				"create rate segment"
			),
		update: (segmentUuid: string, data: any) =>
			callAPI(
				"PUT",
				`${path.base}/planning/travel-routes/rate-segments/${segmentUuid}`,
				data,
				"update rate segment"
			),
		remove: (segmentUuid: string) =>
			callAPI(
				"DELETE",
				`${path.base}/planning/travel-routes/rate-segments/${segmentUuid}`,
				"",
				"delete rate segment"
			),
		// Résout le tarif pour un couple — utilisé par NewPassenger (P3) et l'app chauffeur (P6).
		resolveFare: (
			routeUuid: string,
			fromStopId: number,
			toStopId: number,
			ticketTypeId?: number | null,
		) => {
			const params = new URLSearchParams({
				from_stop_id: String(fromStopId),
				to_stop_id: String(toStopId),
			});
			if (ticketTypeId != null) params.append("ticket_type_id", String(ticketTypeId));
			return callAPI(
				"GET",
				`${path.base}/planning/travel-routes/${routeUuid}/resolve-fare?${params.toString()}`,
				"",
				"resolve fare for segment"
			);
		},
	},
};

export default Routes;
